import * as React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Box,
    Checkbox,
    FormControlLabel,
    Button,
    Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import i18n from '../../utilities/i18n';
import CommonButton from '../commons/Buttons';
import { getStorage } from '../../utilities/browserStorage';

export default function CustomizedDialogs(props) {
    const {
        showModal, setShowModalWindow, header, type, children, eligibility, update,onDownload,
        minHeight,minWidth, addNoOverflowXClass, onHide, resetForm, chkInactive, inactive, setInactive
    } = props;
    const client_view = JSON.parse(getStorage("userData") || "{}");
    const handleClose = () => {
        if (setShowModalWindow) {
            setShowModalWindow(false);
        }
        if (resetForm) resetForm();
        if (onHide) onHide();
    };

    const is = {
        delete: type === 'delete',
        save: type === 'save',
        submit: type === 'formSubmit',
        alert: type === 'alert',
        add: type === 'add',
        assign: type === 'assign',
        merge: type === 'patientmerge',
        reset: type === 'reset',
        send_mail: type === 'sendMail',
        yes: type === 'yes',
        export: type === 'export',
        close:type==="close",
        escalation:type==="escalation",
        audit_review:type==="audit_review"
    };  

    let hideSave = props.hideSave ? props.hideSave : false;

    let selectNPIBtn = props.selectNPIBtn ? props.selectNPIBtn : false;

    let cropImageBtn = props.cropImageBtn ? props.cropImageBtn : false;

    return (
        <Dialog
            open={showModal}
            fullWidth
            maxWidth={false}
            onClose={(_, reason) => reason !== "backdropClick" && handleClose()}
        >
            <DialogTitle
                id="customized-dialog-title"
            >
                {header ?? "\u00A0"}
                {eligibility &&
                    <Box sx={{ display: 'flex',alignItems:'center' }}>
                        <CommonButton
                            variant="update"
                            onClick={update}
                            label={i18n.t('buttons.update')}
                        />
                    </Box>
                }
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 12,
                    top: 10,
                    // color: '#FFFFFF',
                    zIndex: 1
                }}
            >
                <CloseIcon />
            </IconButton>

            {!cropImageBtn &&
                <DialogContent dividers style={{ minHeight: minHeight, minWidth: minWidth }} className={addNoOverflowXClass ? 'overflow-x-hidden' : ''}>
                    {children}
                </DialogContent>
            }
            {cropImageBtn &&
                <DialogContent dividers className='cropImageModalBody'>
                    {children}
                </DialogContent>
            }

            {!props.isNoSaveCancel && (
                <DialogActions>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {is.export && (
                            <FormControlLabel
                                control={<Checkbox checked={!!props.fieldsChecked} onChange={props.onCheckBoxChange} />}
                                label={i18n.t("buttons.selectAll")}
                            />
                        )}
                        {chkInactive && (
                            <FormControlLabel
                                control={<Checkbox checked={inactive} onChange={(e) => setInactive(e.target.checked)} />}
                                label="Inactive"
                            />
                        )}
                        {onDownload && (
                            <Button
                                variant="contained"
                                onClick={onDownload}
                                sx={{
                                    textTransform: 'none',
                                    height: '35px',
                                    backgroundColor: '#0056b3',
                                    '&:hover': {
                                        backgroundColor: '#004494',
                                    },
                                }}
                            >
                                Download
                            </Button>
                        )}
                    </Box>

                    <Box sx={{ display: 'flex', gap: 1.5,alignItems:'center' }}>
                        {is.export &&
                            <CommonButton data-testid="export-btn" label={i18n.t('buttons.export')} variant="outlined" onClick={props.exportData} />
                        }
                        {(!is.alert && type !== 'info' && !is.close) && !is.escalation && !is.audit_review && (
                            <CommonButton
                                label={i18n.t('buttons.cancel')}
                                onClick={handleClose}
                                variant="outlined"
                            />
                        )}
                        {is.escalation && 
                        <Stack direction="row" gap={2}>
                            <CommonButton label={i18n.t('buttons.close')} onClick={handleClose} variant="outlined"/>
                            { !client_view?.view_client_escalation && <CommonButton label={i18n.t('buttons.escalateToManager')} variant="request" onClick={()=>props.onEscalationAction("escalate_to_manager")} />}
                            <CommonButton label={i18n.t('buttons.markAsCompleted')} variant="complete" onClick={()=>props.onEscalationAction("mark_as_complete")} />
                            <CommonButton label={i18n.t('buttons.resolveAndAssign')} variant="contained" onClick={()=>props.onEscalationAction("resolve_and_assign")} />
                        </Stack>}
                        {is.audit_review && 
                        <Stack direction="row" gap={2}>
                            <CommonButton label={i18n.t('buttons.close')} onClick={handleClose} variant="outlined"/>
                            <CommonButton label={i18n.t('buttons.reprove_stage')} variant="danger" onClick={()=>props.onAuditReviewAction("reprove")} />
                            <CommonButton label={i18n.t('buttons.approve_stage')} variant="complete" onClick={()=>props.onAuditReviewAction("approve")} />
                        </Stack>}
                        {is.alert && <CommonButton label={i18n.t('buttons.ok')} variant="contained" onClick={props.alertOK} />}
                        {is.add && <CommonButton label={i18n.t('buttons.add')} variant="contained" onClick={props.add} />}
                        {is.assign && <CommonButton label={i18n.t('buttons.assign')} variant="contained" onClick={props.addAssigned} />}
                        {is.delete && <CommonButton label={i18n.t('buttons.delete')} variant="outlined" color="error" onClick={props.deleteItem} />}
                        {is.save && !hideSave && props.submit !== false &&
                            <Button
                                variant="contained"
                                disabled={props?.insuranceDetails?.length === 0} 
                                form="form_dataEntry" 
                                data-testid="saveButton2"
                                type='submit'
                            >
                                {i18n.t('buttons.save')}
                            </Button>
                        }
                        {is.save && !hideSave &&  props.submit==false &&
                            <CommonButton label={props.saveLabel || i18n.t('buttons.save')} variant="contained" onClick={props.onSaveData} />
                        }
                        {is.submit &&
                            <Button
                                variant="contained"
                                form="formSubmit" id="saveButton" type="button"
                                onClick={props.onSaveFormData}
                            >
                                {i18n.t('buttons.save')}
                            </Button>
                        }
                        
                        {is.close &&
                            <Button
                                variant="contained"
                                onClick={handleClose}
                            >
                                {i18n.t('buttons.close')}
                            </Button>
                        }

                        {is.reset &&
                            <Button
                                variant="contained"
                                form="formSubmit" type="button" onClick={props.onSaveFormData}
                            >
                                {i18n.t('buttons.reset')}

                            </Button>
                        }
                        {is.send_mail &&
                            <Button
                                variant="contained"
                                form="formSubmit" type="button" onClick={props.onSaveFormData}
                            >
                                {i18n.t('buttons.sendMail')}
                            </Button>
                        }

                        {is.yes &&
                           <CommonButton label={i18n.t('buttons.yes')} variant="contained" onClick={props.inactveItem} />
                        }

                        {selectNPIBtn &&
                            <Button
                                variant="contained"
                                form="form_searchNPI"
                                type="submit"
                            >
                                {i18n.t('userPages.practices.labelSelectNPI')}
                            </Button>
                        }

                        {cropImageBtn &&
                           <Button
                                variant="contained"
                                form="form_cropImage" onClick={props.onCropImage}
                            >
                                {i18n.t('buttons.crop')}
                            </Button>
                        }
                        {is.merge &&
                            <CommonButton label={i18n.t('buttons.merge')} variant="contained" icon="merge" onClick={() => props.mergePatientData()} />
                        }

                    </Box>
                </DialogActions>
            )}
        </Dialog>
    );
}